module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Arrows-h-52f888c51022d77d12fb0d7092ef6d44.svg";